module.exports = __webpack_public_path__ + "static/media/excellent.b93633b5.png";